export default __webpack_public_path__ + "static/media/market.89232b21.jpg";